// extracted by mini-css-extract-plugin
module.exports = {"outerCircle":"CurrentStepCircle_outerCircle__2Q2Rv","innerCircle":"CurrentStepCircle_innerCircle__s2sc0"};